import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import {host} from '../../function/api'
import Loading from '../../Loading'
import $ from 'jquery'


import * as Icon from 'react-feather';

function Plans() {
    const [menuData, setMenuData] = useState()
    const dispatch = useDispatch()
    const token = localStorage.getItem('token')
    const menus = useSelector(state => state.navbar.menus)
    const message = useSelector(state => state.navbar.message)
    const [status, setStatus] = useState('')
    const [trackId, setTrackId] = useState('')
    const { username, mobile, email } = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : []
    const [loading, setLoading] = useState('0')
    const [responseStatus, setResponseStatus] = useState('0')
    const rahpardaznet_payment_verify = async() => {
        try {
            setStatus('0')
            let trackId = new URL(location.href).searchParams.get('trackId');
            let orderId = new URL(location.href).searchParams.get('orderId');
            setTrackId(trackId);
            const data = {
                'trackId': trackId,
                'orderId': orderId
            }
            const response = await axios({
                method: 'POST',
                url: `${host}agent/plan/paymnet/verify`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if(response.data.status === true){
                setStatus('1');
            }

            console.log(response);
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 5000,
            })
        }

        setLoading('0');
        setResponseStatus('1');
    }

    useEffect(() => {
        setStatus('0');
        setLoading('1');
        rahpardaznet_payment_verify();

    }, [])
    return (
        <>
        {loading == '1' ? <Loading /> : null}
        {
            (responseStatus == '1') ? (
                
                    (status == '1') ? (
                        
                            <div className="row">
                                <div className="col-12 text-center">
                                
                                <Icon.CheckCircle className='text-success rahpardaznet-icon-payment' />
    
                                </div>
                                <div className="col-12 text-center border-bottom">
                                    <h1 className="text-green">تراکنش موفق</h1>
                                </div>
                                <div className="col-12 text-center border-bottom mt-5 mb-5 pb-5">
                                    <span>
                                        شماره تراکنش:
                                    </span>
                                    <span>
                                        {trackId}
                                    </span>
                                </div>
                            </div>
                        
                    ) : (
                        <div className="row">
                                <div className="col-12 text-center">
                                <Icon.AlertOctagon className='text-danger rahpardaznet-icon-payment' />
                                </div>
                                <div className="col-12 pb-3 text-center border-bottom">
                                    <h1 className="text-danger">تراکنش ناموفق</h1>
                                </div>
                                <div className="col-12 text-center border-bottom mt-5 mb-5 pb-5">
                                    <span>
                                        شماره تراکنش:
                                    </span>
                                    <span>
                                        {trackId}
                                    </span>
                                </div>
                            </div>
                    )
                
            ) : null
        }
            
        </>
    )
}

export default Plans;